export const mutations = {
    LOGIN(state, { account, token }) {
        state.account = account;
        state.accessToken = token;
        state.loggedIn = true;
    },
    UPDATE_TOKEN(state, token) {
        state.accessToken = token;
    },
};
